<template>
  <Transition name="slide-down">
    <div
      v-if="!isOnline || hasPendingOperations"
      :class="[
        'fixed top-0 left-0 right-0 z-50 px-4 py-2 text-center text-white text-sm font-medium',
        isOnline ? 'bg-orange-500' : 'bg-red-500'
      ]"
    >
      <div class="flex items-center justify-center gap-2">
        <svg v-if="!isOnline" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414" />
        </svg>
        <svg v-else class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
        <span v-if="!isOnline">
          Offline režim - data budou synchronizována po obnovení připojení
        </span>
        <span v-else>
          Synchronizace {{ pendingCount }} {{ pendingCount === 1 ? 'položky' : 'položek' }}...
        </span>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { useOfflineSync } from '../../composables/useOfflineSync'

const { isOnline, hasPendingOperations, pendingCount } = useOfflineSync()
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
